import React from 'react';
import { FormattedMessage } from 'react-intl';

export const getFileStatus = (status) => {
  switch (status) {
    case 'VALID_IMPORT': {
      return (
        <FormattedMessage
          id="file_import.valid"
          defaultMessage="Valid"
          className="filter filter--info is-active"
        />
      );
    }
    case 'FAILED_IMPORT': {
      return (
        <FormattedMessage
          id="file_import.failed"
          defaultMessage="Failed"
          className="filter filter--error is-active"
        />
      );
    }
    case 'ACTIVATED': {
      return (
        <FormattedMessage
          id="file_import.activated"
          defaultMessage="Activated"
          className="filter filter--success is-active"
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default {
  getFileStatus,
};
